import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ApiConfiguration } from '@app/api/marketplace/api-configuration';
import { RequestBuilder } from '@app/api/marketplace/request-builder';
import { ImagesService } from '@app/api/marketplace/services';

@Injectable({
  providedIn: 'root',
})
export class ImageWrapperService extends ImagesService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  override createImageToEntity$Response(
    params?: {
      body?: {
        /**
         * Image file resource
         */
        file: Blob;
        imageCreateRequest: Blob;
      };
    },
    context?: HttpContext
  ): Observable<any> {
    const rb = new RequestBuilder(
      this.rootUrl,
      ImagesService.CreateImageToEntityPath,
      'post'
    );
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(
      rb.build({
        responseType: 'json',
        accept: 'application/json',
        context: context,
        reportProgress: true,
      })
    );
  }
}
